import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import React, { useContext, useEffect, useState } from 'react';
import PrivateRoute from './components/PrivateRoute';
import Header from './components/header';
import Footer from './components/footer';
import Login from './pages/Login';
import Reset from './pages/Reset';
import Password from './pages/Password';
import Clubs from './pages/Clubs';
import ClubSingle from './pages/ClubSingle';
import FarmSingle from './pages/FarmSingle';
import ClubInformation from './pages/ClubInformation';
import Profile from './pages/Profile';
import { AuthProvider, AuthContext } from './context/AuthContext';
// import { useAxiosInterceptors } from './axiosSetup';
import { useAxiosInterceptors } from './axiosSetup2';
import Home from './pages/Home';
import Signup from './pages/Signup';
import NoMatch from './pages/NoMatch';
import Logs from './pages/Logs';
import { Toaster } from "./components/ui/toaster"
import MyBunnies from './pages/MyBunnies';
import MyCompetitions from './pages/MyCompetitions';
import Farms from './pages/Farms';
import AddBunny from './pages/AddBunny';
import BunnyInformation from './pages/BunnyInformation';
import FarmInformation from './pages/FarmInformation';
import BunnySingle from './pages/BunnySingle';
import BunnyApproval from './pages/BunnyApproval';
import Bunnies from './pages/Bunnies';
import BunnyRankings from './pages/BunnyRankings';
import UpcomingCompetitions from './pages/UpcomingCompetitions';
import CompetitionClassSingle from './pages/CompetitionClassSingle';
import CompetitionSingle from './pages/CompetitionSingle';
import LitterSingle from './pages/LitterSingle';
import ScrollToTop from './components/scrollToTop'
import { RateLimitContext, RateLimitProvider } from './context/RateLimitContext';
import CompetitionInformation from './pages/CompetitionInformation';
import BunnyRegistrationPage from './pages/BunnyRegistrationPage';
import CompetitionResults from './pages/CompetitionResults';
import PaymentInformation from './pages/PaymentInformation';
import LitterInformation from './pages/LitterInformation';
import api from './lib/api';
import CupSingle from './pages/CupSingle';
import ErrorBoundary from './lib/errorBoundary';
import { UpdateIcon } from '@radix-ui/react-icons';
import OfflineNotification from './components/offlineNotification';
import VersionNotification from './components/versionNotification';


const DevTools = ({ rawToken, auth }) => {
    const { latestFamilyTreeFetch } = useContext(RateLimitContext);

    const [timeLeft, setTimeLeft] = useState({});

    const getExpiryDateFromJWT = (token) => {
        const payload = JSON.parse(atob(token.split('.')[1]));

        // Remove 5s from expiry date to account for latency
        payload.exp = payload.exp - 5;

        return payload.exp * 1000; // Return timestamp in milliseconds
    };

    const calculateTimeLeft = (expiryTimestamp) => {
        const now = Date.now();
        const difference = expiryTimestamp - now;
        let timeLeft = '';

        if (difference > 0) {
            const seconds = Math.floor(difference / 1000);
            timeLeft = `${seconds}s`;
        } else {
            timeLeft = 'Expired';
        }

        return timeLeft;
    };

    useEffect(() => {
        const tokenExpiryTimestamp = getExpiryDateFromJWT(rawToken);
        const familyTreeExpiryTimestamp = latestFamilyTreeFetch + 1000 * 3;

        const interval = setInterval(() => {
            setTimeLeft((prev) => ({
                ...prev,
                token: calculateTimeLeft(tokenExpiryTimestamp),
                familyTree: calculateTimeLeft(familyTreeExpiryTimestamp),
            }));
        }, 100);

        return () => clearInterval(interval);
    }, [rawToken, latestFamilyTreeFetch]);

    return (
        <>
            {auth?.user && (
                <div className='fixed bottom-2 right-2 bg-gray-800 text-white p-2 rounded px-4'>
                    <p className='text-white'>T {timeLeft.token} | FT {timeLeft.familyTree}</p>
                </div>
            )}
        </>
    );
};

const AppContent = () => {
    const [contentReady, setContentReady] = useState(false); // Use state instead of regular variable
    const { auth, loading, logout } = useContext(AuthContext);

    // useAxiosInterceptors();
    const { interceptorReady, isOnline } = useAxiosInterceptors();

    // const pingServerForAuthCheck = async () => {
    //     try {
    //         const response = await api.get('https://skhrf-api.cmdigital.se/ping');

    //         if (response.status === 200) {
    //             setContentReady(true); // Use setContentReady to update the state
    //             return;
    //         }

    //         setContentReady(true);
    //         logout();

    //     } catch (error) {

    //         setContentReady(true);
    //         logout();
    //     }
    // }

    const pingServerForAuthCheck = async () => {
        try {
            // Only try ping if we're online
            if (isOnline) {
                const response = await api.get('https://skhrf-api.cmdigital.se/ping');

                if (response.status === 200) {
                    setContentReady(true);
                    return;
                }

                setContentReady(true);
                logout();
            } else {
                // If offline, just set content ready without trying to ping
                setContentReady(true);
            }
        } catch (error) {
            setContentReady(true);
            // Only logout if it's not an offline error
            if (!error.isOfflineError) {
                logout();
            }
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            pingServerForAuthCheck();
        }, 500);

        // Cleanup function to clear the timeout if the component unmounts
        return () => clearTimeout(timer);
    }, []);

    // Use contentReady to determine when to show the main content
    if (!contentReady) {
        return (
            <div className='w-full h-screen flex items-center justify-center'>
                {/* <h1 className='text-2xl'>Laddar... </h1> */}
                <UpdateIcon className='loader-spinner size-12' />
            </div>
        )
    }

    return (
        <div className='w-full'>
            <Router basename='/'>
                <div className='flex flex-col justify-between min-h-screen'>
                    <div>
                        <Header />
                        <ScrollToTop />
                        {/* <DevTools rawToken={auth.accessToken} auth={auth} /> */}
                        <ErrorBoundary auth={auth}>
                            <Routes>
                                <Route path='/' element={<Clubs />} />
                                <Route path='/login' element={<Login />} />
                                <Route path='/reset-request' element={<Reset />} />
                                <Route path='/reset-password' element={<Password />} />
                                <Route path='/clubs' element={<Clubs />} />
                                <Route path='/clubs/:clubId' element={<ClubSingle />} />
                                <Route path='/clubs/:clubId/clubinformation' element={<PrivateRoute component={ClubInformation} />} />
                                <Route path='/profile/:userId' element={<PrivateRoute component={Profile} />} />
                                <Route path='/signup' element={<Signup />} />
                                <Route path='/system' element={<PrivateRoute component={Logs} />} />
                                <Route path='/bunnies' element={<PrivateRoute component={Bunnies} />} />
                                <Route path='/mybunnies' element={<PrivateRoute component={MyBunnies} />} />
                                <Route path='/mycompetitions' element={<PrivateRoute component={MyCompetitions} />} />
                                <Route path='/bunny/:bunnyId/edit' element={<PrivateRoute component={BunnyInformation} />} />
                                <Route path='/bunny/:bunnyId' element={<PrivateRoute component={BunnySingle} />} />
                                <Route path='/add-bunny' element={<PrivateRoute component={AddBunny} />} />
                                <Route path='/bunny-approval' element={<PrivateRoute component={BunnyApproval} />} />
                                <Route path='/bunny-rankings' element={<PrivateRoute component={BunnyRankings} />} />
                                <Route path='/upcoming' element={<PrivateRoute component={UpcomingCompetitions} />} />
                                <Route path='/results' element={<PrivateRoute component={CompetitionResults} />} />
                                <Route path='/paymentinformation/:clubId' element={<PrivateRoute component={PaymentInformation} />} />
                                <Route path='/competition/:competitionId' element={<PrivateRoute component={CompetitionSingle} />} />
                                <Route path='/competition/:competitionId/class/:competitionClassId' element={<PrivateRoute component={CompetitionClassSingle} />} />
                                <Route path='/competition/:competitionId/cup/:cupId' element={<PrivateRoute component={CupSingle} />} />
                                <Route path='/competition/:competitionId/register' element={<PrivateRoute component={BunnyRegistrationPage} />} />
                                <Route path='/competition/:competitionId/edit' element={<PrivateRoute component={CompetitionInformation} />} />
                                <Route path='/add-competition/' element={<PrivateRoute component={CompetitionInformation} />} />
                                <Route path='/farms' element={<PrivateRoute component={Farms} />} />
                                <Route path='/farms/:farmId' element={<PrivateRoute component={FarmSingle} />} />
                                <Route path='/farms/:farmId/edit' element={<PrivateRoute component={FarmInformation} />} />
                                <Route path='/litters/:litterId' element={<PrivateRoute component={LitterSingle} />} />
                                <Route path='/litters/:litterId/edit' element={<PrivateRoute component={LitterInformation} />} />
                                <Route path="*" element={<NoMatch />} />
                            </Routes>
                        </ErrorBoundary>
                    </div>
                    <Footer />
                </div>
            </Router>
            <Toaster />
            <OfflineNotification />
            <VersionNotification />
        </div>
    );
}

const App = () => {
    return (
        <AuthProvider>
            <RateLimitProvider>
                <AppContent />
            </RateLimitProvider>
        </AuthProvider>
    );
};

export default App;
